import { useNavigate } from 'react-router-dom';

import { useTheme } from '@mui/material';
import { BookText, Mail, SquareArrowOutUpRight, Keyboard } from 'lucide-react';

import { Page, PageHeader } from '@/components';
const HelpPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Page>
      <PageHeader title="Help and support" />
      <div
        className="flex gap-4 p-4 mt-4 rounded-md"
        style={{ backgroundColor: theme.palette.background.paper }}
      >
        <a
          href="mailto:support@911systems.com"
          className="flex justify-between border border-gray-200 dark:border-gray-700 rounded-md w-96 p-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer no-underline text-inherit text-gray-900 dark:text-gray-100"
        >
          <div className="flex gap-4">
            <Mail strokeWidth={1.5} />
            <div className="w-full flex flex-col">
              <span className="font-medium">Email support</span>
              <span className="text-gray-500 dark:text-gray-400 text-sm">
                support@911systems.com
              </span>
            </div>
          </div>
          <SquareArrowOutUpRight strokeWidth={1.5} />
        </a>
        <div
          className="flex justify-between border border-gray-200 dark:border-gray-700 rounded-md w-96 p-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer text-gray-900 dark:text-gray-100"
          onClick={() => navigate('/help/release-notes')}
        >
          <div className="flex gap-4">
            <BookText strokeWidth={1.5} />
            <div className="w-full flex flex-col">
              <span className="font-medium">Release notes</span>
              <span className="text-gray-500 dark:text-gray-400 text-sm">
                View release notes
              </span>
            </div>
          </div>
          <SquareArrowOutUpRight strokeWidth={1.5} />
        </div>
        <div
          className="flex justify-between border border-gray-200 dark:border-gray-700 rounded-md w-96 p-4 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer text-gray-900 dark:text-gray-100"
          onClick={() => navigate('/keyboard-shortcuts')}
        >
          <div className="flex gap-4">
            <Keyboard strokeWidth={1.5} />
            <div className="w-full flex flex-col">
              <span className="font-medium">Keyboard Shortcuts</span>
              <span className="text-gray-500 dark:text-gray-400 text-sm">
                View keyboard shortcuts
              </span>
            </div>
          </div>
          <SquareArrowOutUpRight strokeWidth={1.5} />
        </div>
      </div>
    </Page>
  );
};

export default HelpPage;
